
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_336_20980)"}},[_c('path',{attrs:{"d":"M12 0C5.374 0 0 5.374 0 12s5.374 12 12 12 12-5.374 12-12S18.626 0 12 0zm5.48 9.356c.004.118.007.237.007.356 0 3.64-2.77 7.837-7.837 7.837a7.796 7.796 0 01-4.222-1.237 5.527 5.527 0 004.078-1.14 2.757 2.757 0 01-2.573-1.914 2.742 2.742 0 001.244-.047 2.755 2.755 0 01-2.21-2.7v-.035c.383.212.81.33 1.248.344a2.752 2.752 0 01-.852-3.677 7.82 7.82 0 005.677 2.878 2.755 2.755 0 014.694-2.512 5.524 5.524 0 001.748-.669 2.765 2.765 0 01-1.21 1.524 5.494 5.494 0 001.58-.434 5.597 5.597 0 01-1.373 1.426z","fill":"#1EABF1"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_336_20980"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h24v24H0z"}})])])])
          )
        }
      }
    